import { styled } from '@mui/material/styles';
import { ReactElement, SyntheticEvent, useEffect, useState } from 'react';
import { MenuStateProvider } from '../../../../../components/DropdownMenu/MenuContext';
import { MuiSingleSelect, Option } from '../../../../../components/MuiSingleSelect/MuiSingleSelect';
import { useColumnSelector, useSelectorColumns } from '../../../providers/ColumnSelectorProvider';
import { ColumnItemDropdownToggler } from './ColumnItemDropdownToggler';

interface Props {
  locked: boolean;
  column: Option;
}
const Container = styled('div')`
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ColumnItemDropdownImp = ({ column, locked }: Props): ReactElement => {
  const data = useSelectorColumns();
  const { activeOrder, setActiveOrder } = useColumnSelector();
  const [items, setItems] = useState<Option[]>([]);

  useEffect(() => {
    const result: Option[] = [];
    data?.forEach((c) => {
      if (!activeOrder.includes(c.name)) {
        result.push({ id: c.name, value: c.displayName });
      }
    });
    setItems(result);
  }, [activeOrder, data]);

  const onColumnChange = (e: SyntheticEvent, newColumn: Option | null) => {
    if (!newColumn) {
      return;
    }
    const newActiveOrder = activeOrder.map((c) => (c === column.id ? (newColumn.id as string) : c));
    setActiveOrder(newActiveOrder);
  };

  if (locked || !items?.length) {
    return (
      <Container>
        <ColumnItemDropdownToggler column={column} locked={locked} />
      </Container>
    );
  }

  return (
    <Container>
      <MuiSingleSelect
        options={items}
        onChange={onColumnChange}
        value={column}
        style={{ width: '100%' }}
        sx={{ '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' } }}
      />
    </Container>
  );
};

export const ColumnItemDropdown = (props: Props) => (
  <MenuStateProvider>
    <ColumnItemDropdownImp {...props} />
  </MenuStateProvider>
);
